export const PAGE = {
  MEZHKOMNATNYE_DVERI:               'mezhkomnatnye-dveri',
  VHODNYE_DVERI:                     'vhodnye-dveri',
};